// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: qJ5gCB8LACfk
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import SelectState from "../../SelectState"; // plasmic-import: Xi3_llZ3Sz6q/component
import SelectState__Option from "../../SelectState__Option"; // plasmic-import: Xn7o6HjeyNhf/component
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicNewSelectState.module.css"; // plasmic-import: qJ5gCB8LACfk/css

createPlasmicElementProxy;

export const PlasmicNewSelectState__VariantProps = new Array();

export const PlasmicNewSelectState__ArgProps = new Array();

const $$ = {};

function PlasmicNewSelectState__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "selectState.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <SelectState
      data-plasmic-name={"selectState"}
      data-plasmic-override={overrides.selectState}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames("__wab_instance", sty.selectState)}
      onChange={async (...eventArgs) => {
        ((...eventArgs) => {
          generateStateOnChangeProp($state, ["selectState", "value"])(
            eventArgs[0]
          );
        }).apply(null, eventArgs);
        if (
          eventArgs.length > 1 &&
          eventArgs[1] &&
          eventArgs[1]._plasmic_state_init_
        ) {
          return;
        }
      }}
      placeholder={
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text
          )}
        >
          {"State"}
        </div>
      }
      value={generateStateValueProp($state, ["selectState", "value"])}
    >
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__esUwy)}
        value={"AL"}
      >
        {"Alabama"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__cyO2C)}
        value={"AK"}
      >
        {"Alaska"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__ozhQh)}
        value={"AZ"}
      >
        {"Arizona"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__ljktf)}
        value={"AR"}
      >
        {"Arkansas"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__xeX3N)}
        value={"CA"}
      >
        {"California"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__kCeg)}
        value={"CO"}
      >
        {"Colorado"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__oDjCm)}
        value={"CT"}
      >
        {"Connecticut"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__lAd36)}
        value={"DE"}
      >
        {"Delaware"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__z7Bkf)}
        value={"DC"}
      >
        {"District of Columbia"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option___8Kbfm)}
        value={"FL"}
      >
        {"Florida"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__gkuxs)}
        value={"GA"}
      >
        {"Georgia"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__rr6Oa)}
        value={"GU"}
      >
        {"Guam"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option___1Q1)}
        value={"HI"}
      >
        {"Hawaii"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__hfq2S)}
        value={"ID 2"}
      >
        {"Idaho"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option___6CMq7)}
        value={"IL"}
      >
        {"Illinois"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__vbRaT)}
        value={"ID"}
      >
        {"Idaho"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__l6Vtj)}
        value={"IN"}
      >
        {"Indiana"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__sLz1X)}
        value={"IA"}
      >
        {"Iowa"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__jYrmt)}
        value={"KS"}
      >
        {"Kansas"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__ovhL)}
        value={"KY"}
      >
        {"Kentucky"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__uCmGg)}
        value={"LA"}
      >
        {"Louisiana"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__y3Iw7)}
        value={"ME"}
      >
        {"Maine"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__qzic1)}
        textValue={""}
        value={"MH"}
      >
        {"Marshall Islands"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__i9K9A)}
        value={"MD"}
      >
        {"Maryland"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__uYxkk)}
        value={"MA"}
      >
        {"Massachusetts"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__yoyHp)}
        value={"MI"}
      >
        {"Michigan"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__s3Zvh)}
        value={"MN"}
      >
        {"Minnesota"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__kqKj6)}
        value={"MS"}
      >
        {"Mississippi"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__pLBjT)}
        value={"MO"}
      >
        {"Missouri"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__d4Cpe)}
        value={"MT"}
      >
        {"Montana"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option___15Yx)}
        value={"NE"}
      >
        {"Nebraska"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__euRcz)}
        value={"NV"}
      >
        {"Nevada"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__a6Xfk)}
        value={"NH"}
      >
        {"New Hampshire"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__uAjyi)}
        value={"NJ"}
      >
        {"New Jersey"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__lUhJl)}
        value={"NM"}
      >
        {"New Mexico"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__eYvk)}
        value={"NY"}
      >
        {"New York"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__l1KQn)}
        value={"NC"}
      >
        {"North Carolina"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__tVjgP)}
        value={"ND"}
      >
        {"North Dakota"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__zEXzH)}
        value={"OH"}
      >
        {"Ohio"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__xgpz)}
        value={"OK"}
      >
        {"Oklahoma"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__kfNn1)}
        value={"OR"}
      >
        {"Oregon"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option___7LulS)}
        value={"PA"}
      >
        {"Pennsylvania"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__oheNh)}
        value={"PR"}
      >
        {"Puerto Rico"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__wOzAu)}
        value={"RI"}
      >
        {"Rhode Island"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__ij3Hd)}
        value={"SC"}
      >
        {"South Carolina"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__vqWN)}
        value={"SD"}
      >
        {"South Dakota"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__eBhX)}
        value={"TN"}
      >
        {"Tennessee"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__ga5Xn)}
        value={"TX"}
      >
        {"Texas"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__aiJ6)}
        value={"UT"}
      >
        {"Utah"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__nWd0S)}
        value={"VT"}
      >
        {"Vermont"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__axEX)}
        value={"VI"}
      >
        {"Virgin Islands"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__pl6JU)}
        value={"VA"}
      >
        {"Virginia"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option___2OdjS)}
        value={"WA"}
      >
        {"Washington"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__eUtqJ)}
        value={"WV"}
      >
        {"West Virginia"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__cjwnj)}
        value={"WI"}
      >
        {"Wisconsin"}
      </SelectState__Option>
      <SelectState__Option
        className={classNames("__wab_instance", sty.option__lhPmC)}
        value={"WY"}
      >
        {"Wyoming"}
      </SelectState__Option>
    </SelectState>
  );
}

const PlasmicDescendants = {
  selectState: ["selectState", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNewSelectState__ArgProps,
          internalVariantPropNames: PlasmicNewSelectState__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNewSelectState__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "selectState") {
    func.displayName = "PlasmicNewSelectState";
  } else {
    func.displayName = `PlasmicNewSelectState.${nodeName}`;
  }
  return func;
}

export const PlasmicNewSelectState = Object.assign(
  // Top-level PlasmicNewSelectState renders the root element
  makeNodeComponent("selectState"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicNewSelectState
    internalVariantProps: PlasmicNewSelectState__VariantProps,
    internalArgProps: PlasmicNewSelectState__ArgProps
  }
);

export default PlasmicNewSelectState;
/* prettier-ignore-end */
